import Glide, { Controls, Breakpoints } from "@glidejs/glide/dist/glide.modular.esm";

const featuresSlider = new Glide(".glide", {
  type: "carousel",
  perView: 1,
  animationDuration: 0,
  gap: 20,
  breakpoints: {
    768: {
      animationDuration: 400,
      peek: 0,
    },
    1024: {
      animationDuration: 400,
      peek: {
        before: 0,
        after: 300,
      },
    },
  },
});

featuresSlider.mount({ Controls, Breakpoints });
